import { Colors } from '@amelio/ui-library';

import surveyBackground from '@/assets/media/surveyBack.png';

// Decorative background shown behind the survey question and completion screens.
export const MANAGER_ASSESSMENT_SURVEY_IMAGE_URL = surveyBackground;

// Proficiency scale palette (worst → best), using the ui-library CHART colours so every level up to
// the max of 6 gets a distinct colour; callers spread proportionally when the org has fewer (min 3).
// The Quick Assessment grid displays worst → best, so index 0 is the lowest level.
export const PROFICIENCY_LEVEL_COLORS = [
    Colors.CHART_RED,
    Colors.CHART_ORANGE,
    Colors.CHART_YELLOW,
    Colors.CHART_LIME,
    Colors.CHART_GREEN,
    Colors.CHART_TEAL,
];
